import styles from '../singleMiniFeedback.module.scss';
import moment from 'moment';

export const MiniFeedbackStats = ({
  totalResponses,
  clickThreshold,
  createdAt,
}) => {
  return (
    <div className={styles.statsContainer}>
      <div className={styles.statCard}>
        <div className={styles.statLabel}>TOTAL RESPONSES</div>
        <div className={styles.statValue}>
          {totalResponses?.toLocaleString() || 0}
        </div>
      </div>
      <div className={styles.statCard}>
        <div className={styles.statLabel}>CLICK THRESHOLD</div>
        <div className={styles.statValue}>{clickThreshold || 0} clicks</div>
      </div>

      <div className={styles.statCard}>
        <div className={styles.statLabel}>CREATED</div>
        <div className={styles.statValue}>
          {moment(createdAt).format('MMM D, YYYY')}
        </div>
      </div>
    </div>
  );
};
